import React from 'react';
import { Container } from 'flux/utils';

import Dialog from 'components/Dialog.jsx';
import Messages from 'collections/Messages';
import Group from 'entities/Group';
import GroupScheduledMessageList from 'groups/components/GroupScheduledMessageList.jsx';
import MessageStore from 'groups/stores/MessageStore';
import { getGroupKey } from 'utils/roleHelpers';

import styles from './styles/ScheduledAnnouncementsDialog.css';

class ScheduledAnnouncementsDialog extends React.Component {

  static propTypes = {
    messagesScheduled: React.PropTypes.instanceOf(Messages).isRequired,
    group: React.PropTypes.instanceOf(Group).isRequired,
  };

  static getStores() {
    return [MessageStore];
  }

  static calculateState(prevState, props) {
    const { group, target } = props;
    let role = '';
    if (target) {
      role = target.role;
    }
    if (group) {
      return {
        messagesScheduled: MessageStore.getMessagesScheduled(getGroupKey(group.id, role)),
      };
    }

    return {};
  }

  constructor(props) {
    super(props);
    this.state = {
      messagesScheduled: props.messagesScheduled,
    };
  }

  componentDidUpdate() {
    if (!this.state.messagesScheduled ||
        this.state.messagesScheduled.isEmpty()) {
      this.props.onRequestHide();
    }
  }

  renderScheduledMessages() {
    return (
      <GroupScheduledMessageList
        group={this.props.group}
        className={styles.messageList}
        messages={this.state.messagesScheduled}
      />
    );
  }

  render() {
    return (
      <Dialog
        eventScreenName="ScheduledAnnouncementsDialog"
        {...this.props}
        className={styles.this}
        title="Scheduled Announcements"
        size="medium">
        <div className={styles.dialogBodyWrapper}>
          {this.renderScheduledMessages()}
        </div>
      </Dialog>
    );
  }
}

export default Container.create(ScheduledAnnouncementsDialog, {
  withProps: true,
  pure: false,
});



// WEBPACK FOOTER //
// ./src/chat/components/ScheduledAnnouncementsDialog.jsx